import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0201',
    ecrans: ['00-2']
});

